import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors.js'

export interface ParameterItem {
    label: string
    value: string
}

export interface QuestionItem {
    label: string
    description: string
    data_type?: string
}

export interface QuestionCategory {
    categoryName: string
    categoryID: number
    questions: QuestionItem[]
}

export type QuestionCategoriesMap = Record<string, QuestionCategory>

export interface AiTemplate {
    TemplateID: number
    Name: string
    Template: string
    AccountID: number
    LanguageID: number
}

export interface PromptTemplate {
    PromptTemplateID: number
    PromptTemplateName: string
    Description: string
    SystemPrompt: string
    UserPrompt: string
}

export const widgetParameterApi = {
    /**
     * Fetches CDR (Call Detail Record) parameters list
     * @returns List of CDR parameter options
     */
    async getCDRList (): Promise<ParameterItem[]> {
        try {
            const { Data } = await $axios.get('/WidgetParameter/CDRList/')
            return Data || []
        } catch (e) {
            parseCatch(e, false, 'Widget Parameter CDR List')
            return []
        }
    },

    /**
     * Fetches Calls Custom Variables list
     * @returns List of custom variable parameter options
     */
    async getCallsCustomVariablesList (): Promise<ParameterItem[]> {
        try {
            const { Data } = await $axios.get('/WidgetParameter/CallsCustomVariablesList/')
            return Data || []
        } catch (e) {
            parseCatch(e, false, 'Widget Parameter Custom Variables List')
            return []
        }
    },

    async getQuestionsList (): Promise<QuestionCategoriesMap> {
        try {
            const { Data } = await $axios.get('/WidgetParameter/QuestionsV2/')
            return Data || {}
        } catch (e) {
            parseCatch(e, false, 'Widget Parameter Questions List')
            return {}
        }
    },

    /**
     * Fetches AI Template list
     * @param body - Request body (user will customize this)
     * @returns List of AI templates
     */
    async getAiTemplateList (body: Record<string, unknown> = { fetchGlobals: true }): Promise<AiTemplate[]> {
        try {
            const { Data } = await $axios.post('/Summarizer/CDRTemplateList/', body)
            return Data || []
        } catch (e) {
            parseCatch(e, false, 'AI Template List')
            return []
        }
    },

    async getPromptTemplatesList (): Promise<PromptTemplate[]> {
        try {
            const { Data } = await $axios.get('/Summarizer/PromptTemplatesList/')
            return Data || []
        } catch (e) {
            parseCatch(e, false, 'Prompt Templates List')
            return []
        }
    }
}
